import * as React from 'react'
import { useForm, UseFormRegister, UseFormGetValues } from 'react-hook-form'

import {
  SearchConditionDate as Presenter,
  IProps as IPresenterProps,
} from './presenter'
import {
  trackingUserContext,
  searchEventIdContext,
} from '@/contexts/trackingContexts'
import { trackEvent } from '@/utils/analyze'

interface IProps
  extends Omit<
    IPresenterProps,
    | 'setDateHandler'
    | 'setTodayHandler'
    | 'setTomorrowHandler'
    | 'resetHandler'
    | 'submitHandler'
    | 'resetDateHandler'
    | 'resetTimeHandler'
    | 'workTimeFrom'
    | 'workTimeTo'
    | 'workTimeFromUnselected'
    | 'workTimeToUnselected'
    | 'setHandler'
    | 'setWorkTimeFromHandler'
    | 'setWorkTimeToHandler'
    | 'setWorkTimeFromUnselectedHandler'
    | 'setWorkTimeToUnselectedHandler'
  > {
  register: UseFormRegister<ISearchConditionState>
  getValues: UseFormGetValues<ISearchConditionState>
  submitHandler: (state: ISearchConditionState) => void
}

export const SearchConditionDate = ({
  getValues,
  ...props
}: IProps): JSX.Element => {
  const user = React.useContext(trackingUserContext)
  const eventIds = React.useContext(searchEventIdContext)
  const selectDate = getValues('search.work_date_from')
  const workTimeFrom =
    getValues('search.work_time_from') !== ''
      ? getValues('search.work_time_from')
      : '12:00'
  const workTimeTo =
    getValues('search.work_time_to') !== ''
      ? getValues('search.work_time_to')
      : '13:00'
  const workTimeFromUnselected = getValues('search.work_time_from_unselected')
    ? getValues('search.work_time_from_unselected')
    : 0
  const workTimeToUnselected = getValues('search.work_time_to_unselected')
    ? getValues('search.work_time_to_unselected')
    : 0

  const setWorkTimeFromHandler = (timeString: string) => {
    setValue('search.work_time_from', timeString)
  }
  const setWorkTimeToHandler = (timeString: string) => {
    setValue('search.work_time_to', timeString)
  }
  const setWorkTimeFromUnselectedHandler = (value: number) => {
    setValue('search.work_time_from_unselected', value)
  }
  const setWorkTimeToUnselectedHandler = (value: number) => {
    setValue('search.work_time_to_unselected', value)
  }
  const useFormObject = useForm<ISearchConditionState>({
    defaultValues: {
      search: {
        work_date_from: selectDate,
        work_time_from: workTimeFrom,
        work_time_to: workTimeTo,
        work_time_from_unselected: workTimeFromUnselected,
        work_time_to_unselected: workTimeToUnselected,
      },
    },
  })

  const { setValue, watch, reset } = useFormObject
  const watchAllFields = watch()
  const localWorkTimeFrom = watchAllFields.search.work_time_from
  const localWorkTimeTo = watchAllFields.search.work_time_to
  const localWorkTimeFromUnselected =
    watchAllFields.search.work_time_from_unselected
  const localWorkTimeToUnselected =
    watchAllFields.search.work_time_to_unselected
  const localDateFrom = watchAllFields.search.work_date_from

  const setDateHandler = (date: Date) => {
    setValue('search.work_date_from', date)
  }
  const setTodayHandler = (date: Date) => {
    trackEvent(eventIds.SEARCH_MODAL_DATE_CLICK_TODAY, user)
    setDateHandler(date)
  }
  const setTomorrowHandler = (date: Date) => {
    trackEvent(eventIds.SEARCH_MODAL_DATE_CLICK_TOMORROW, user)
    setDateHandler(date)
  }
  const submitHandler = () => {
    trackEvent(eventIds.SEARCH_MODAL_DATE_SUBMIT, user)
    props.submitHandler(watchAllFields)
  }

  const resetDateHandler = () => {
    setValue('search.work_date_from', null)
  }

  const resetTimeHandler = () => {
    reset({
      search: {
        work_time_from: '12:00',
        work_time_to: '13:00',
        work_time_from_unselected: 0,
        work_time_to_unselected: 0,
      },
    })
  }

  return (
    <Presenter
      {...props}
      setDateHandler={setDateHandler}
      selectedDate={localDateFrom}
      setTodayHandler={setTodayHandler}
      setTomorrowHandler={setTomorrowHandler}
      submitHandler={submitHandler}
      resetDateHandler={resetDateHandler}
      resetTimeHandler={resetTimeHandler}
      workTimeFrom={localWorkTimeFrom}
      workTimeTo={localWorkTimeTo}
      workTimeFromUnselected={localWorkTimeFromUnselected}
      workTimeToUnselected={localWorkTimeToUnselected}
      setWorkTimeFromHandler={setWorkTimeFromHandler}
      setWorkTimeToHandler={setWorkTimeToHandler}
      setWorkTimeFromUnselectedHandler={setWorkTimeFromUnselectedHandler}
      setWorkTimeToUnselectedHandler={setWorkTimeToUnselectedHandler}
    />
  )
}
